import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import PageNumber from './../../../components/atoms/PageNumber';

const Intro = () => {
    return(
        <section className="intro" id="section2">
            <Container style={{ maxWidth: '2000px' }}>
                <Row>
                    <Col>
                    <div className="intro__pagenumber--wrapper">
                    <PageNumber title="about me" count="01"> </PageNumber>
                    </div>
                    <div className="intro__image-wrapper">
                        <div className="intro__frame">
                        </div>
                    </div>
                    <div className="intro__text-wrapper">

                    <div className="intro__content-wrapper">
                        <p className="intro__title"> Hi, </p>
                        <p className="intro__text"> My name is Hayen, and I'm a composer, sound designer, and audio implementer. 

<br></br>I create authentic music and sound design to enhance storytelling and strengthen each game’s unique identity. 

Being drawn to unconventional ideas, I enjoy pushing creative boundaries to find the perfect sound for every project.
 </p>
                        {/* <div className="intro__wave">  </div> */}
                    </div>
                    </div>

                    </Col>
                </Row>
            </Container>
        </section>
    )
};

export default Intro;
